import React, { useEffect } from 'react';
import { ENV_CONFIG } from '../../../constants/envConfig';
import { AEM_CONTAINS_PHONE_NUMBER } from '../constants';
import { applicationErrorShimmerEffect } from '../utils/shimmerUtil';
import { updateJoinCashFailedFlag } from '../cashFlow/utils/cashflowUtils';
import { PHONE_NUMBER_VERIFICATION } from '../cashFlow/constants';
import { useAnalyticsContext } from '../../../config/GoogleTagManagerEvents';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../constants/analyticsConstants/Ecommerce';
import './applicationError.scss';
import { convertPhoneNumberAsPerSbmChannel } from '../../global/utils/commonUtils';

const ApplicationError = props => {
    const { sendEventsForPageViewed } = useAnalyticsContext();

    const {
        GR_HEADER_TITLE_LABEL_ERROR = '',
        GR_APPLICATION_STATUS_MESSAGE_ERROR = '',
        GR_CUSTOMER_SERVICE_NUMBER_ERROR = '',
        GR_APPLICATION_STATUS_ICON_ERROR = '',
        GR_APPLICATION_STATUS_ALT_TEXT_ERROR = ''
    } = ENV_CONFIG || {};

    useEffect(() => {
        applicationErrorShimmerEffect();
        //call join cash fail api and navigate to error screen if join cash page
        {location.pathname.includes(PHONE_NUMBER_VERIFICATION) ?  sendEventAndUpdateFlag() : ''}
    }, []);

    const sendEventAndUpdateFlag = () => {    
        updateJoinCashFailedFlag();    
        sendEventsForPageViewed(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_PAGE_VIEWED,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_JOIN_CASH_ERROR_FORM_NAME,
            window.location.href
        );
    };

    const GrCustomerNumber = convertPhoneNumberAsPerSbmChannel(GR_CUSTOMER_SERVICE_NUMBER_ERROR);
    const subTitle = (
        <p
            className="application-error__helpline"
            data-testid="gr-application-error-sub-title"
            dangerouslySetInnerHTML={{
                __html: GR_APPLICATION_STATUS_MESSAGE_ERROR?.replace(
                    AEM_CONTAINS_PHONE_NUMBER,
                    `<a href="tel:${GrCustomerNumber}">${GrCustomerNumber}</a>`
                )
            }}></p>
    );

    return (
        <div className="container">
            <div className="row stepform__row">
                <div className="col-lg-6">
                    <div className="application-error">
                        <div className="warning-indicator">
                            <div className="warning-overlay">
                                <img
                                    src={GR_APPLICATION_STATUS_ICON_ERROR}
                                    alt={GR_APPLICATION_STATUS_ALT_TEXT_ERROR}
                                />
                            </div>
                        </div>

                        <div className="application-error__content">
                            <h4 className="application-error__header">{GR_HEADER_TITLE_LABEL_ERROR}</h4>
                            {subTitle}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ApplicationError.propTypes = {};

export default ApplicationError;
